/* eslint-disable @typescript-eslint/no-explicit-any */
import { useTracking } from '@facephi/sdk-web';
import { RequestMethods, useRequest, useVariables, useLogger } from '../hooks';
import { endPoints, StatusOperations } from '../states';

type documentSidesParameters = {
  result?: StatusOperations;
  operationId: string;
  demoVersion: string;
  session?: string;
};

export const useDocumentValidation = () => {
  const { apiDemoUrl } = useVariables();
  const { requestBasic: demoRequest } = useRequest(apiDemoUrl);
  const { sessionId } = useTracking();
  const { captureException } = useLogger();

  const sendSidesCorrespondence = async ({
    operationId,
    demoVersion,
    result,
    session,
  }: documentSidesParameters) => {
    try {
      const responseValidation: any = await demoRequest(
        endPoints.DocumentSides,
        {
          method: RequestMethods.post,
          headers: {
            'x-demo-app-version': demoVersion,
            'x-inphinite-operationid': operationId,
            'x-inphinite-sessionid': sessionId || session,
          },
          data: {
            result,
          },
        }
      );
      return responseValidation;
    } catch (e: any) {
      captureException(e, {
        operation: 'sendSidesCorrespondence',
        url: endPoints.DocumentSides,
        operationId: operationId,
      });
      throw new Error(e);
    }
  };

  return { sendSidesCorrespondence };
};
